import { render, staticRenderFns } from "./wcSearch.vue?vue&type=template&id=132965af"
import script from "./wcSearch.vue?vue&type=script&lang=js"
export * from "./wcSearch.vue?vue&type=script&lang=js"
import style0 from "./wcSearch.vue?vue&type=style&index=0&id=132965af&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports